<template>
  <v-container
    grid-list-md
    fluid
    class="pa-2"
  >
    <v-layout
      column
    >
      <v-flex 
        v-if="componentLoading"
        d-flex
        justify-center
      >
        <v-progress-circular
          :size="64"
          :width="3"
          indeterminate
          color="primary"
        />
      </v-flex>
      <v-flex
        v-else
        xs12
      >
        <v-card
          id="kioskContent"
          class="max-shadow"
        >
          <v-toolbar
            color="white"
            flat
            height="48"
          >
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                color="primary"
                flat
                @click="addKioskDialog = true"
              >
                Add kiosk
              </v-btn>
              <v-btn
                color="primary"
                flat
                @click="addPrinterDialog = true"
              >
                Add printer
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-layout
            v-for="device in devices"
            :key="device.id"
            class="mx-3 scrollable border"
            row
            wrap
          >
            <v-flex
              xs12
            >
              <device
                :device="device"
                :devices="devices"
                @edit="editDevice($event)"
                @unpair="unpairDevice($event)"
              />
            </v-flex>
          </v-layout>
        </v-card>
        <v-dialog
          v-model="editDeviceDialog"
          lazy
          max-width="700px"
          transition="dialog-transition"
          :persistent="editDeviceDialogPersist"
        >
          <edit-device 
            :device="selectedDevice"
            :devices="devices"
            :kiosks="kiosks"
            :printers="printers"
            @closeDialog="editDeviceDialog = false ; editDeviceDialogPersist = false"
            @persistDialog="editDeviceDialogPersist = true"
            @success="success"
            @error="error"
          />
        </v-dialog>
        <v-dialog
          v-model="unpairDeviceDialog"
          lazy
          max-width="700px"
          transition="dialog-transition"
          :persistent="unpairLoader"
        >
          <v-card class="max-shadow">
            <v-card-title primary-title>
              <div class="headline">
                {{ `Confirm ${selectedDevice.deviceOS === 'PRINTER'? 'delete': 'unpair'} device` }}
              </div>
            </v-card-title>
            <v-card-text>
              <div class="subheading">
                {{ `This device will be disconnected from your account.
                You can re-login into this device and set new location to use this device
                again.  Are you sure you want ${selectedDevice.deviceOS === 'PRINTER'? 'delete': 'unpair'} this device?` }}
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                flat
                color="primary"
                :disabled="unpairLoader"
                @click.stop="unpairDeviceDialog = false"
              >
                Cancel
              </v-btn>
              <v-btn
                flat
                color="primary"
                :loading="unpairLoader"
                @click.stop="confirmUnpairDevice"
              >
                {{ selectedDevice.deviceOS === 'PRINTER'? 'delete': 'unpair' }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="addKioskDialog"
          lazy
          max-width="700px"
          transition="dialog-transition"
          :persistent="addKioskDialogPersist"
        >
          <add-kiosk
            :show="addKioskDialog"
            @closeDialog="addKioskDialog = false; addKioskDialogPersist = false"
            @error="error"
            @success="success"
            @persistDialog="addKioskDialogPersist = true"
          />
        </v-dialog>
        <v-dialog
          v-model="addPrinterDialog"
          lazy
          max-width="700px"
          transition="dialog-transition"
          :persistent="addPrinterDialogPersist"
        >
          <add-printer 
            :kiosks="kiosks"
            :printers="printers"
            @closeDialog="addPrinterDialog = false; addPrinterDialogPersist = false"
            @error="error"
            @success="success"
            @persistDialog="addPrinterDialogPersist = true"
          />
        </v-dialog>
        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :timeout="0"
          bottom
        >
          {{ snackbarMessage }}
          <v-btn
            flat
            @click.native="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { database, functions } from '@/firebase';
import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';
import AddKiosk from './AddKiosk';
import Device from './Device';
import EditDevice from './EditDevice';
import AddPrinter from './AddPrinter';
export default {
  name: 'Devices',
  components: {
    'add-kiosk': AddKiosk,
    'edit-device': EditDevice,
    'add-printer': AddPrinter,
    device: Device
  },
  data() {
    return {
      devices: [],
      editDeviceDialog: false,
      unpairDeviceDialog: false,
      unpairLoader: false,
      addKioskDialog: false,
      addPrinterDialog: false,

      addPrinterDialogPersist: false,
      addKioskDialogPersist: false,
      editDeviceDialogPersist: false,

      selectedDevice: {},
      ipRegex: /^\b(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\b$/,
      firebaseListeners: [],
      componentLoading: true,
      snackbarMessage: '',
      snackbarColor: 'primary',
      snackbar: false
    };
  },
  computed: {
    locationId() {
      return _get(this.$store.state.VMS, 'lid');
    },
    deviceRef() {
      const lid = _get(this.$store.state.VMS, 'lid');
      // return null if the location ID is not yet set
      if (!lid) return null;

      return database.ref(`vms/devices`);
    },
    printers() {
      return this.devices.filter(device => device.deviceOS === 'PRINTER');
    },
    kiosks() {
      return this.devices.filter(device => device.deviceOS !== 'PRINTER');
    }
  },
  watch: {
    deviceRef: {
      handler(val) {
        if (!val) return;

        this.firebaseListeners.forEach(listenerFunc => {
          val.off('value', listenerFunc);
        });

        this.fetchDevices();
      },
      immediate: true
    }
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Devices' });
  },
  beforeDestroy() {
    this.firebaseListeners.forEach(listenerFunc => {
      this.deviceRef.off('value', listenerFunc);
    });
  },
  methods: {
    fetchDevices() {
      const fetchDevice = this.deviceRef
        .orderByChild('lid')
        .equalTo(`${this.locationId}`)
        .on('value', deviceSnapshot => {
          if (!deviceSnapshot) return;
          const devices = deviceSnapshot.val();
          const devicesArray = this._toArray(devices);
          this.devices = devicesArray;
          this.componentLoading = false;
        });
      this.firebaseListeners.push(fetchDevice);
    },
    _toArray(obj) {
      if (!obj) return [];
      return Object.keys(obj).map(key => {
        const item = obj[key];
        item.id = key;
        return item;
      });
    },
    error(err) {
      this.snackbarColor = 'error';
      this.snackbarMessage = `${err.code} ${err.message}`;
      this.snackbar = true;
    },
    success(msg) {
      this.snackbarColor = 'primary';
      this.snackbarMessage = msg;
      this.snackbar = true;
    },

    unpairDevice(device) {
      this.selectedDevice = device;
      this.unpairDeviceDialog = true;
    },

    editDevice(device) {
      this.selectedDevice = _cloneDeep(device);
      this.editDeviceDialog = true;
    },
    confirmUnpairDevice() {
      const device = this.selectedDevice;
      this.unpairLoader = true;
      if (device.deviceOS === 'PRINTER') {
        this.deviceRef
          .child(device.id)
          .set(null)
          .then(() => {
            this.unpairLoader = false;
            this.unpairDeviceDialog = false;
          })
          .catch(error => {
            this.snackbarMessage = `${error.code} ${error.message}`;
            this.snackbarColor = 'error';
            this.snackbar = true;
            this.unpairLoader = false;
            this.unpairDeviceDialog = false;
          });
      } else {
        const unpairKiosk = functions.httpsCallable('vms-kiosks-unpairKiosk');
        unpairKiosk({
          kid: device.id
        })
          .then(() => {
            this.unpairLoader = false;
            this.unpairDeviceDialog = false;
          })
          .catch(err => {
            this.snackbarMessage = `${err.code} ${err.message}`;
            this.snackbarColor = 'error';
            this.snackbar = true;
            this.unpairLoader = false;
            this.unpairDeviceDialog = false;
          });
      }
    }
  }
};
</script>
<style scoped>
.border {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.scrollable {
  overflow-y: scroll;
  overflow-x: hidden;
}
#kioskContent {
  height: calc(100vh - var(--toolbar-height)) !important;
  overflow-y: scroll;
}
#kioskContent .v-text-field {
  margin-top: 0;
  padding-top: 0;
}
.v-input--selection-controls {
  margin-top: 0;
}
.addNegMargin {
  margin-top: -30px;
}
</style>

